// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.conversation.type.SatelliteConversationFeatureType

export enum SatelliteConversationFeatureType {
  INVITE_TO_APPLY = 'INVITE_TO_APPLY',
  REQUEST_RENTER_PROFILE = 'REQUEST_RENTER_PROFILE',
  SCHEDULE_TOUR = 'SCHEDULE_TOUR',
  SEND_MESSAGE = 'SEND_MESSAGE',
  VIEW_MESSAGES = 'VIEW_MESSAGES',
  VIEW_RENTER_JOURNEY = 'VIEW_RENTER_JOURNEY',
  VIEW_SCREENING_CRITERIA = 'VIEW_SCREENING_CRITERIA',
  VIEW_TOUR_DETAILS = 'VIEW_TOUR_DETAILS',
}

export const SatelliteConversationFeatureType_values = [
  SatelliteConversationFeatureType.INVITE_TO_APPLY,
  SatelliteConversationFeatureType.REQUEST_RENTER_PROFILE,
  SatelliteConversationFeatureType.SCHEDULE_TOUR,
  SatelliteConversationFeatureType.SEND_MESSAGE,
  SatelliteConversationFeatureType.VIEW_MESSAGES,
  SatelliteConversationFeatureType.VIEW_RENTER_JOURNEY,
  SatelliteConversationFeatureType.VIEW_SCREENING_CRITERIA,
  SatelliteConversationFeatureType.VIEW_TOUR_DETAILS,
] as const;
